import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getAttributeTemplates,
	getAttributeTemplatesEndpoint,
	type QueryError,
	type GetAttributeTemplatesResult,
} from '../getAttributeTemplates';
export * from '../getAttributeTemplates';

export type GetAttributeTemplatesQueryKey = [string];

export type GetAttributeTemplatesReactQueryOptions = Omit<
	UseQueryOptions<
		GetAttributeTemplatesResult,
		QueryError,
		GetAttributeTemplatesResult,
		GetAttributeTemplatesQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetAttributeTemplatesReactQueryKey = getAttributeTemplatesEndpoint;

export const useReactQueryGetAttributeTemplates = (
	options?: GetAttributeTemplatesReactQueryOptions,
) =>
	useQuery<
		GetAttributeTemplatesResult,
		QueryError,
		GetAttributeTemplatesResult,
		GetAttributeTemplatesQueryKey
	>({
		queryFn: () => getAttributeTemplates(),
		queryKey: [getAttributeTemplatesEndpoint],
		...options,
	});

export default useReactQueryGetAttributeTemplates;
